import React from 'react'
import CreateClass from '../../components/admin/CreateIndividual/CreateClass'

function CreateClassPage({ defaultStep }) {
  return <CreateClass defaultStep={defaultStep} />
}

export default CreateClassPage
